import { StoredLink } from './type/StoredLink';

type T = (link: StoredLink) => boolean;

const f: T = (link) => link.fetchCounter >= 5;

export default f;
